export enum BestTimeToContact {
  'Morning' = 0,
  'Afternoon' = 1,
  'Evening' = 2,
}
